// react core
import { useState, useEffect } from "react";

// imported animations
// import Marquee from "react-fast-marquee";

// material design
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grow from "@mui/material/Grow";
// import Zoom from "@mui/material/Zoom";
import Typography from "@mui/material/Typography";

// fonts and icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes as iconClose } from "@fortawesome/pro-thin-svg-icons";
import { faInfoCircle as iconAbout } from "@fortawesome/pro-regular-svg-icons";
import { faSignIn as iconConnect } from "@fortawesome/pro-regular-svg-icons";

// import { faExplosion as iconLaunchedDuo } from "@fortawesome/pro-duotone-svg-icons";
// import { faExplosion as iconLaunchedThin } from "@fortawesome/pro-thin-svg-icons";
// import { faBurst as iconBurstDuo } from "@fortawesome/pro-duotone-svg-icons";
// import { faBurst as iconBurstThin } from "@fortawesome/pro-thin-svg-icons";
// import { faCircle as iconCircleDuo } from "@fortawesome/pro-duotone-svg-icons";
// import { faCircle as iconCircleReg } from "@fortawesome/pro-solid-svg-icons";
// import { faRing as iconRing } from "@fortawesome/pro-duotone-svg-icons";
// import { faPeopleGroup as iconBoom } from "@fortawesome/pro-duotone-svg-icons";
// import { faPlay as iconGo } from "@fortawesome/pro-thin-svg-icons";
// import { faInfoCircle as iconInfo } from "@fortawesome/pro-thin-svg-icons";
// import { faCircleCalendar as iconCalendar } from "@fortawesome/pro-duotone-svg-icons";
// import { orange, red } from "@mui/material/colors/";
// import { faAtomAlt as iconStart } from "@fortawesome/pro-thin-svg-icons";
// import { faArrowAltRight as iconArrowLeft } from "@fortawesome/pro-solid-svg-icons";
// import { faArrowAltLeft as iconArrowRight } from "@fortawesome/pro-solid-svg-icons";
// import { faCaretRight as iconArrowGoRight } from "@fortawesome/pro-duotone-svg-icons";
// import { faCog as iconSettings } from "@fortawesome/pro-thin-svg-icons";
// import { faMessageHeart as iconSupport } from "@fortawesome/pro-duotone-svg-icons";
// import { faAtomAlt as iconEventuators } from "@fortawesome/pro-thin-svg-icons";
// import { faSquare as iconSquare } from "@fortawesome/pro-solid-svg-icons";
// import { faSpeaker as iconSpeaker } from "@fortawesome/pro-duotone-svg-icons";
// import { faCircle as iconCircleBubble } from "@awesome.me/kit-5934ee9dac/icons/notdog/solid";

// entzy config models and components
import configEntzy from "components/config/ConfigEntzy";
import AboutExperiment from "components/about/AboutExperiment";

// import Hero from "components/utils/custom/CustomHero";
import { scrollSnapTop } from "models/Tools";

// entzy assets
import imageHero0 from "assets/heros/map-signal-main.png";
// import imageHero1 from "assets/heros/tribe-finder-people.png";
// import imageHero2 from "assets/heros/events-bar.png";
// import imageHero3 from "assets/heros/calendar-confirmed.png";
// import imageHero4 from "assets/heros/tribe-finder-outdoor.png";

// import HomeSpotlight from "./HomeSpotlight";
import { ActionBoxButton } from "components/utils/common/CommonButtons";
// import { TagLine } from "components/utils/common/CommonTags";
import { ModuleSubHeaderTag } from "components/utils/common/CommonTags";

// entzy assets
import BadgeGooglePlay from "assets/badges/google-play.png";
import BadgeAppleStore from "assets/badges/apple-store.svg";
// import { scrollSnapTop, scrollIntoViewIfNeeded } from "models/Tools";

// function BoomAvatar(props) {
//   const [zoom, setZoom] = useState(0);

//   // toggle zoom on a 6 second delay for 10 times
//   useEffect(() => {
//     const timer = setInterval(() => {
//       setZoom(zoom + 1);
//     }, 3000);
//     if (zoom > 20) {
//       clearInterval(timer);
//     }
//     return () => clearInterval(timer);
//   }, [zoom]);

//   return (
//     <Box
//       className="box-default"
//       sx={{
//         fontSize: configEntzy.FONT_SCALE_MD,
//       }}
//     >
//       <Box className="box-default">
//         <Box component="span" className="fa-layers fa-fw fa-8x">
//           <FontAwesomeIcon
//             icon={iconBurstDuo}
//             style={{ opacity: 0.4, color: "purple" }}
//             transform="grow-96 down-2"
//           />
//           <FontAwesomeIcon
//             icon={iconCircleBubble}
//             style={{ color: "black" }}
//             transform="grow-36 down-2"
//             className="shadow-purple-glow"
//           />
//           <FontAwesomeIcon
//             icon={iconCalendar}
//             className="fa-beat"
//             transform="grow-40 down-3"
//             style={{
//               "--fa-animation-duration": "2s",
//               "--fa-beat-scale": 1.05,
//               color: "purple",
//             }}
//           />
//           <FontAwesomeIcon
//             icon={iconLaunchedDuo}
//             style={{ color: orange[500] }}
//           />
//           <FontAwesomeIcon
//             icon={iconLaunchedThin}
//             style={{ color: orange[900] }}
//           />
//           <FontAwesomeIcon
//             icon={iconCircleDuo}
//             transform="shrink-3"
//             style={{ color: orange[500] }}
//           />
//           <FontAwesomeIcon
//             icon={iconCircleDuo}
//             transform="shrink-6"
//             style={{ color: orange[700] }}
//           />
//           <FontAwesomeIcon
//             icon={iconCircleReg}
//             transform="shrink-9"
//             style={{ color: orange[200] }}
//           />
//           <FontAwesomeIcon
//             icon={iconBoom}
//             color="black"
//             transform="shrink-12"
//           />
//         </Box>
//       </Box>
//       <Box
//         className="box-default"
//       >
//         <Zoom
//           in={
//             zoom % 2 === 0
//           }
//           timeout={2000}
//         >
//           <Box
//             className="box-default relative zero-height"
//             sx={{
//               zIndex: 1,
//             }}
//           >
//             <Typography
//               variant="h3"
//               color="white"
//               sx={{ mt: configEntzy.APP_SPACING_SM }}
//             >
//               <span>Eventuate</span>
//             </Typography>
//           </Box>
//         </Zoom>
//         <Zoom
//           in={
//             zoom % 2 !== 0
//           }
//           timeout={2000}
//         >
//           <Box
//             className="box-default relative zero-height"
//             sx={{
//               zIndex: 1,
//             }}
//           >
//             <Typography
//               variant="h3"
//               color="white"
//               sx={{ mt: configEntzy.APP_SPACING_SM }}
//             >
//               <span>Let's Go</span>
//             </Typography>
//           </Box>
//         </Zoom>
//       </Box>
//     </Box>
//   );
// }

function HomeLanding(props) {
  // const [start, setStart] = useState(false);
  const [showAbout, setShowAbout] = useState(false);
  const [heroTitle, setHeroTitle] = useState("Put your signal up");
  const [heroSubtitle, setHeroSubtitle] = useState("For human connection");

  // const handleToggleStart = () => {
  //   const element = document.getElementById("anchor-lets-go");
  //   if (element) scrollIntoViewIfNeeded(element);
  //   setStart(!start);
  // };

  const handleToggleShowAbout = () => {
    scrollSnapTop();
    setShowAbout(!showAbout);
  };
  const handleConnect = () => {
    props.drawerConnectToggle();
  };

  // effect to rotate the here title and subtitle through the worlds most spoken languages every 7 seconds
  useEffect(() => {
    const titles = [
      { title: "Put your signal up", subtitle: "For human connection" }, // English
      { title: "Ponga su señal", subtitle: "Para la conexión humana" }, // Spanish
      { title: "Put your signal up", subtitle: "For human connection" }, // English
      { title: "Mettez votre signal", subtitle: "Pour la connexion humaine" }, // French
      { title: "Put your signal up", subtitle: "For human connection" }, // English
      {
        title: "Stellen Sie Ihr Signal ein",
        subtitle: "Für menschliche Verbindung",
      }, // German
      { title: "Put your signal up", subtitle: "For human connection" }, // English
      {
        title: "Metti su il tuo segnale",
        subtitle: "Per la connessione umana",
      }, // Italian
      { title: "Put your signal up", subtitle: "For human connection" }, // English
      { title: "Coloque seu sinal", subtitle: "Para a conexão humana" }, // Portuguese
      { title: "Put your signal up", subtitle: "For human connection" }, // English
      { title: "Ustaw swój sygnał", subtitle: "Dla ludzkiego połączenia" }, // Polish
      { title: "Put your signal up", subtitle: "For human connection" }, // English
      { title: "Настройте свой сигнал", subtitle: "Для человеческой связи" }, // Russian
      { title: "Put your signal up", subtitle: "For human connection" }, // English
      { title: "Nastavite svoj signal", subtitle: "Za ljudsku povezanost" }, // Croatian
      { title: "Put your signal up", subtitle: "For human connection" }, // English
      { title: "放置信号", subtitle: "为了人类的联系" }, // Chinese (Simplified)
      { title: "Put your signal up", subtitle: "For human connection" }, // English
      { title: "シグナルを設定する", subtitle: "人間のつながりのために" }, // Japanese
      { title: "Put your signal up", subtitle: "For human connection" }, // English
      { title: "अपने सिग्नल सेट करें", subtitle: "मानव कनेक्शन के लिए" }, // Hindi
    ];
    let index = 0;
    const interval = setInterval(() => {
      index = (index + 1) % titles.length;
      setHeroTitle(titles[index].title);
      setHeroSubtitle(titles[index].subtitle);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box className="box-default">
      <Box
        className="box-default"
        sx={{
          pt: configEntzy.APP_SPACING_MD2X,
        }}
      >
        <Container maxWidth="md" disableGutters>
          {showAbout ? (
            <Box className="box-default">
              <Box
                className="box-inline right action-pointer"
                sx={{
                  mr: configEntzy.APP_SPACING_MD,
                  width: configEntzy.AVATAR_SIZE_SM,
                }}
                onClick={handleToggleShowAbout}
              >
                <FontAwesomeIcon icon={iconClose} size="2x" />
              </Box>
              <AboutExperiment {...props} />
            </Box>
          ) : (
            <Box
              className="box-default nooverflow"
              sx={{
                pt: configEntzy.APP_SPACING_MD2X,
                px: configEntzy.APP_SPACING_MD2X,
                pb: configEntzy.APP_SPACING_MD2X,
              }}
            >
              <Box className="box-default">
                <Typography
                  variant="h6"
                  color="white"
                  align="center"
                  className="glowing-text"
                  sx={{
                    mb: configEntzy.APP_SPACING_MD,
                    letterSpacing: "0.3em",
                  }}
                >
                  ENTZY
                </Typography>
                <Typography
                  variant="h3"
                  color="white"
                  align="center"
                  sx={{ mb: configEntzy.APP_SPACING_MD3X }}
                >
                  Community Builder
                </Typography>
              </Box>

              <Box className="box-default">
                <Box
                  className="box-inline shadow-orange-glow action-pointer"
                  sx={{
                    width: configEntzy.AVATAR_CONTAINER_LG,
                    height: configEntzy.AVATAR_CONTAINER_LG,
                    borderRadius: "50%",
                    backgroundImage: `url(${imageHero0})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    opacity: 0.9,
                  }}
                  onClick={() => handleConnect()}
                ></Box>
              </Box>

              <Box
                key={heroTitle}
                className="box-default"
                sx={{
                  mt: configEntzy.APP_SPACING_MD2X,
                }}
              >
                <Box className="box-inline">
                  <Grow in={true} timeout={500}>
                    <Typography
                      variant="h3"
                      color="primary"
                      align="center"
                      sx={{ mb: configEntzy.APP_SPACING_SMd }}
                    >
                      {heroTitle}
                    </Typography>
                  </Grow>
                  <Grow in={true} timeout={2000}>
                    <Typography variant="h6" color="white" align="center">
                      {heroSubtitle}
                    </Typography>
                  </Grow>
                </Box>
              </Box>

              <Box
                className="box-default"
                sx={{
                  mt: configEntzy.APP_SPACING_MD2X,
                }}
              >
                <Typography
                  variant="h6"
                  color="white"
                  align="center"
                  sx={{ textWrap: "balance" }}
                >
                  Find your tribe and grow local community with simple repeat
                  meets
                </Typography>
              </Box>

              <Box
                className="box-default"
                sx={{
                  mt: configEntzy.APP_SPACING_MD3X,
                }}
              >
                <Box
                  className="box-default half-width"
                  sx={{
                    pr: configEntzy.APP_SPACING_MD,
                  }}
                >
                  <ActionBoxButton
                    variant="contained"
                    size="large"
                    text={
                      <span>
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        Explore
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <FontAwesomeIcon icon={iconAbout} fixedWidth />
                      </span>
                    }
                    bgColor="black"
                    color="white"
                    borderColor="purple"
                    onClick={() => handleToggleShowAbout()}
                  />
                </Box>
                <Box
                  className="box-default half-width"
                  sx={{
                    pl: configEntzy.APP_SPACING_MD,
                  }}
                >
                  <ActionBoxButton
                    variant="contained"
                    size="large"
                    text={
                      <span>
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        Connect
                        <span>&nbsp;&nbsp;&nbsp;</span>
                        <FontAwesomeIcon icon={iconConnect} fixedWidth />
                      </span>
                    }
                    bgColor="black"
                    color="white"
                    borderColor="orange"
                    onClick={() => handleConnect()}
                  />
                </Box>
              </Box>

              {/* <Box
                className="box-default nooverflow shadow-default shadow-orange-glow"
                sx={{
                  borderRadius: configEntzy.BORDER_SIZE_XL,
                }}
              >
                <Hero
                  key={heroTitle}
                  image={imageHero0}
                  eyebrow="Entzy"
                  title={heroTitle}
                  subtitle={heroSubtitle}
                  align="center"
                  bulletList={[
                    {
                      spacer: true,
                      height: { xs: "10rem", md: "15rem" },
                    },
                  ]}
                  primaryAction={{
                    variant: "outlined",
                    label: "Connect",
                    onClick: () => handleConnect(),
                  }}
                  secondaryAction={{
                    variant: "outlined",
                    label: "About",
                    onClick: () => handleToggleShowAbout(),
                  }}
                />
              </Box> */}
            </Box>
          )}
        </Container>
      </Box>

      {/* <Box
        id="anchor-lets-go"
        className="box-default"
        sx={{
          pt: configEntzy.APP_SPACING_HL,
        }}
        hidden={showSpotlight}
      >
        <Container maxWidth="lg">
          <Box className="box-default">
            <Grow in={!start} timeout={1000}>
              <Box className="box-default" hidden={start}>
                <Box
                  className="box-default action-pointer"
                  sx={{
                    mt: configEntzy.APP_SPACING_HL,
                    pt: configEntzy.APP_SPACING_XL,
                    pb: configEntzy.APP_SPACING_HL,
                  }}
                  onClick={handleToggleStart}
                >
                  <BoomAvatar />
                </Box>

                <Box
                  className="box-default relative pop-up"
                  sx={{
                    mt: configEntzy.APP_SPACING_XL2X,
                  }}
                >
                  <Typography variant="h6" color={orange[600]}>
                    Getting together is our super power
                  </Typography>
                  <TagLine text="💡" bookends={true} />
                  <TagLine text="Ideas are the magic sauce" />
                </Box>
              </Box>
            </Grow>
            <Grow in={start} timeout={1000}>
              <Box className="box-default" hidden={!start}>
                <Box
                  className="box-default"
                  sx={{
                    height: configEntzy.AVATAR_CONTAINER_MD,
                  }}
                >
                  <Box
                    className="box-inline right"
                    sx={{
                      mt: configEntzy.APP_SPACING_NLG2X,
                      width: configEntzy.AVATAR_SIZE_MD,
                    }}
                  >
                    <BigButton
                      size="sm"
                      icon={iconClose}
                      iconColor="white"
                      bgColor="transparent"
                      textColor="white"
                      text=" "
                      onClick={handleToggleStart}
                    />
                  </Box>
                </Box>
                <Box
                  className="box-default relative pop-up"
                  sx={{ mt: configEntzy.APP_SPACING_NHL }}
                >
                  <Box className="box-inline left">
                    <ActionBoxButton
                      variant="contained"
                      size="large"
                      type="button"
                      text="About Entzy"
                      circular={true}
                      bgColor="black"
                      borderColor="purple"
                      color="white"
                      onClick={() => props.menuSelectById("about")}
                      topIcon={
                        <FontAwesomeIcon
                          icon={iconInfo}
                          className="fa-beat"
                          style={{
                            "--fa-animation-duration": "1.5s",
                            "--fa-beat-scale": 1.1,
                          }}
                          color="orange"
                          size="3x"
                          fixedWidth
                        />
                      }
                    />
                  </Box>
                  <Box className="box-inline right">
                    <ActionBoxButton
                      variant="contained"
                      size="large"
                      type="button"
                      text="Have a play"
                      circular={true}
                      bgColor="black"
                      borderColor="purple"
                      color="white"
                      onClick={() => {
                        scrollSnapTop();
                        props.navigate("/eventuators");
                      }}
                      topIcon={
                        <FontAwesomeIcon
                          icon={iconGo}
                          className="fa-beat"
                          style={{
                            "--fa-animation-duration": "1.5s",
                            "--fa-beat-scale": 1.1,
                          }}
                          color="orange"
                          size="3x"
                          fixedWidth
                        />
                      }
                    />
                  </Box>
                </Box>
                <Box className="box-default zero-height">
                  <Typography variant="subtitle2">
                    <FontAwesomeIcon
                      icon={iconBurstDuo}
                      size="10x"
                      style={{ opacity: 0.8, color: red[900] }}
                      transform="grow-50 down-7"
                    />
                  </Typography>
                  <Typography
                    variant="h1"
                    color="white"
                    sx={{
                      mt: configEntzy.APP_SPACING_NLG,
                    }}
                  >
                    {configEntzy.URL_POINTERS.BOT}
                  </Typography>
                </Box>

                <Box
                  className="box-default relative pop-up"
                  sx={{ height: configEntzy.AVATAR_SIZE_LG }}
                >
                  <Typography variant="h6">&nbsp;</Typography>
                </Box>

                <Box
                  className="box-default relative pop-up"
                  sx={{ pt: configEntzy.APP_SPACING_MD }}
                >
                  <Box className="box-inline left">
                    <ActionBoxButton
                      variant="contained"
                      size="large"
                      type="button"
                      text="Eventuators"
                      circular={true}
                      bgColor="black"
                      borderColor="purple"
                      color="white"
                      onClick={handleToggleSpotlight}
                      topIcon={
                        <FontAwesomeIcon
                          icon={iconEventuators}
                          className="fa-beat"
                          style={{
                            "--fa-animation-duration": "1.5s",
                            "--fa-beat-scale": 1.1,
                          }}
                          color="orange"
                          size="3x"
                          fixedWidth
                        />
                      }
                    />
                  </Box>
                  <Box className="box-inline right">
                    <ActionBoxButton
                      variant="contained"
                      size="large"
                      type="button"
                      text="Connect"
                      circular={true}
                      bgColor="black"
                      borderColor="purple"
                      color="white"
                      onClick={() => props.drawerConnectToggle()}
                      topIcon={
                        <FontAwesomeIcon
                          icon={iconConnect}
                          className="fa-beat"
                          style={{
                            "--fa-animation-duration": "1.5s",
                            "--fa-beat-scale": 1.1,
                          }}
                          color="orange"
                          size="3x"
                          fixedWidth
                        />
                      }
                    />
                  </Box>
                </Box>
              </Box>
            </Grow>
          </Box>
        </Container>
      </Box> */}

      <Box
        className="box-default footer-height"
        sx={{
          mt: configEntzy.APP_SPACING_HL,
        }}
      >
        <ModuleSubHeaderTag text="App Downloads" />
        <Box className="box-inline">
          <Box
            className="box-default half-width"
            sx={{ p: configEntzy.APP_SPACING_SM }}
          >
            <a
              href={
                "https://apps.apple.com/us/app/entzy/id1543725422?ct=" +
                configEntzy.APP_DOMAIN
              }
              target="_blank"
              rel="noopener noreferrer"
              className="image-link"
            >
              <img
                alt="Download on the App Store"
                src={BadgeAppleStore}
                className="app-badge-apple"
              />
            </a>
          </Box>
          <Box
            className="box-default half-width"
            sx={{ p: configEntzy.APP_SPACING_SM }}
          >
            <a
              href={
                "https://play.google.com/store/apps/details?id=com.entzy.twa&utm_source=" +
                configEntzy.APP_DOMAIN
              }
              target="_blank"
              rel="noopener noreferrer"
              className="image-link"
            >
              <img
                alt="Get it on Google Play"
                src={BadgeGooglePlay}
                className="app-badge-google"
              />
            </a>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default HomeLanding;
